<!-- 任务列表日志弹窗 -->
<template>
    <div class="popup" v-cloak v-show="viewLogsShow">
        <div class="content" id="viewLogs">
            <div class="title">
                <div class="title-text">
                    <span v-if="summary&&summary.tranferWay == 'restore'">{{$t('language.popup.viewLogsPopup.titleRe')}}</span>
                    <span v-else>{{$t('language.popup.viewLogsPopup.title')}}</span>
                    {{taskName}}
                </div>
                <div class="icon white-close dialog-close" @click="closePage()"></div>
            </div>
            <div class="view-logs-body" v-loading="loading">
                <!-- 未执行过的任务 -->
                <div class="view-logs-none" v-if="!loading&&!summary">{{$t('language.common.taskNotRun')}}</div>
                <!-- 汇总信息 -->
                <div class="view-logs-summary" v-if="!loading&&summary">
                    <!-- 状态 -->
                    <div class="view-logs-status">
                        <!-- 成功 -->
                        <div class="view-logs-status-item" v-if="result==1">
                            <div class="task-success task-status-icon-big"></div>
                            <div>{{$t('language.common.success')}}</div>
                        </div>
                        <!-- 部分成功 -->
                        <div class="view-logs-status-item" v-if="result==2">
                            <div class="task-patial task-status-icon-big"></div>
                            <div>{{$t('language.common.patial')}}</div>
                        </div>
                        <!-- 失败 -->
                        <div class="view-logs-status-item" v-if="result==-1">
                            <div class="task-failure task-status-icon-big"></div>
                            <div>{{$t('language.common.failure')}}</div>
                        </div>
                        <!-- 关闭 -->
                        <div class="view-logs-status-item" v-if="result==0">
                            <div class="task-cancel task-status-icon-big"></div>
                            <div>{{$t('language.common.canceled')}}</div>
                        </div>
                        <!-- 其他 -->
                        <div class="view-logs-status-item" v-if="result!=0&&result!=-1&&result!=1&&result!=2">
                            <div class="task-status-icon-big"></div>
                            <div> </div>
                        </div>
                    </div>
                    <!-- 统计 -->
                    <div>
                        <!-- 同步 -->
                        <div class="view-logs-census" v-if="typeId==102">
                            <!-- 失败个数 -->
                            <div class="view-logs-count have-click-text" style="color: #F54958;" v-if="summary.errorNum"  @click="openFailedFiles()">
                                <div class="view-logs-count-num">
                                    {{summary.errorNum}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.errorNum')}}</div>
                            </div>
                            <!-- 增加个数 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.addNum}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.addNum')}}</div>
                            </div>
                            <!-- 修改个数 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.updateNum}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.updateNum')}}</div>
                            </div>
                            <!-- 删除个数 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.deleteNum}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.deleteNum')}}</div>
                            </div>
                            <!-- 同步大小 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.totalBytes|formatByte}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.syncSize')}}</div>
                            </div>
                            <!-- 同步耗时 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.runningTime|conversionMilliseconds}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.syncTime')}}</div>
                            </div>
                        </div>
                        <!-- 备份 -->
                        <div class="view-logs-census" v-if="typeId==103">
                            <!-- 失败个数 -->
                            <div class="view-logs-count have-click-text" style="color: #F54958;" v-if="summary.errorNum" @click="openFailedFiles()">
                                <div class="view-logs-count-num">
                                    {{summary.errorNum}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.errorNum')}}</div>
                            </div>
                            <!-- 成功个数 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.totalNum}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.backupNum')}}</div>
                            </div>
                            <!-- 成功传输大小 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.totalBytes|formatByte}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.backupSize')}}</div>
                            </div>
                            <!-- 传输总时间 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.runningTime|conversionMilliseconds}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.backupTime')}}</div>
                            </div>
                        </div>
                        <!-- 一般传输 -->
                        <div class="view-logs-census" v-if="typeId!=103&&typeId!=102">
                            <!-- 失败个数 -->
                            <div class="view-logs-count have-click-text" style="color: #F54958;" v-if="summary.errorNum"  @click="openFailedFiles()">
                                <div class="view-logs-count-num">
                                    {{summary.errorNum}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.errorNum')}}</div>
                            </div>
                            <!-- 成功个数 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.totalNum}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.tranNum')}}</div>
                            </div>
                            <!-- 成功传输大小 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.totalBytes|formatByte}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.tranSize')}}</div>
                            </div>
                            <!-- 传输总时间 -->
                            <div class="view-logs-count">
                                <div class="view-logs-count-num">
                                    {{summary.runningTime|conversionMilliseconds}}
                                </div>
                                <div>{{$t('language.popup.viewLogsPopup.tranTime')}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 源或目标信息 -->
                <div class="view-logs-source" v-if="!loading&&summary">
                    <!-- 单源或单目标信息 -->
                    <div class="view-logs-source-items">
                        <!-- 单源 -->
                        <div class="view-logs-source-singel" :style="typeId==104?'padding-left: 15px;':''">
                            <div class="source-name" v-if="typeId!=104">
                                <span v-if="lang=='jp'">
                                    <span v-if="typeId==102">{{$t('language.popup.viewLogsPopup.sync')}}</span>
                                    <span v-if="typeId==103">{{$t('language.popup.viewLogsPopup.backup')}}</span>
                                    <span v-if="typeId!=103&&typeId!=102">{{$t('language.popup.viewLogsPopup.tran')}}</span>
                                </span>
                                <span v-if="viewDetail.type == 1 || (viewDetail.type == 6 && summary.tranferWay != 'restore')">
                                    {{$t('language.popup.viewLogsPopup.to')}}       
                                </span>
                                <span v-else>
                                    {{$t('language.popup.viewLogsPopup.from')}}
                                </span>
                                <span v-if="lang=='jp'">：</span>
                                <div class="path-name-txt" @click.stop="jumpToCloud(singleSource)" :title="singleSource.nodes|getCatalog">{{singleSource.nodes|getCatalog}}</div>
                            </div>
                            <div class="source-name" v-else>
                                <!-- 企业传输 -->
                                <div class="task-icon clouds_logo clouds_logo_20" :class="summary.fromItem.cloudType"></div>
                                <div class="source-email-name" :title="summary.fromItem.fileName" @click.stop="jumpToCloud(summary.fromItem)">{{summary.fromItem.fileName}}</div>
                                <div class="double_arrow"></div>
                                <div class="task-icon clouds_logo clouds_logo_20" :class="summary.toItem.cloudType"></div>
                                <div class="source-email-name" :title="summary.toItem.fileName" @click.stop="jumpToCloud(summary.toItem)">{{summary.toItem.fileName}}</div>
                            </div>
                            <div v-if="summary.startTime">
                                <el-dropdown v-if="typeId==102 && syncSourceList.length>1" @command="handleSyncSource">
                                    <span class="el-dropdown-link">
                                        {{$t('language.popup.viewLogsPopup.executeTime')}} {{summary.startTime|transferForMatTime}} - {{summary.endTime|transferForMatTime}}<i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" style="padding:0;">
                                        <el-dropdown-item class="logs-popup-drop" v-for="(log,index) in syncSourceList" :key="index" :command=index>{{log.summary.startTime|transferForMatTime}} - {{log.summary.endTime|transferForMatTime}}</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <span v-else>{{$t('language.popup.viewLogsPopup.executeTime')}} {{summary.startTime|transferForMatTime}} - {{summary.endTime|transferForMatTime}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 多源或多目标信息 -->
                    <div class="view-logs-source-items">
                        <!-- 多源 -->
                        <div class="view-logs-source-table" :class="typeId!=104?'un-business-tran':''">
                            <el-table :data="multiSource" stripe tooltip-effect="dark" style="width: 100%" height="390">
                                <el-table-column :label="$t('language.popup.viewLogsPopup.sourceAccount')" min-width="260" v-if="typeId==104">
                                    <template slot-scope="scope">
                                        <div class="table-cell" :title="scope.row.fromEmail">{{scope.row.fromEmail}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('language.popup.viewLogsPopup.targetAccounts')" min-width="260" v-if="typeId==104">
                                    <template slot-scope="scope">
                                        <div class="table-cell" :title="scope.row.toEmail">{{scope.row.toEmail}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="showFromOrToTableName" :min-width="typeId!=102?520:420" v-else>
                                    <template slot-scope="scope">
                                        <div class="small-file" :class="scope.row.source.isDir?'folder-small':matchfileType(scope.row.source.name)"></div>
                                        <div class="table-cell path-name-txt" :title="scope.row.source.nodes|getCatalog" @click.stop="jumpToCloudMult(scope.row.source)">{{scope.row.source.nodes|getCatalog}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('language.common.fileProcess')" :min-width="typeId!=102?175:230">
                                    <template slot-scope="scope">
                                        <div class="table-cell">
                                            <div v-if="typeId!=102">{{scope.row.readyNum}} / {{scope.row.totalNum}}</div>
                                            <div v-else>{{$t('language.popup.viewLogsPopup.add')+scope.row.addNum+" "+$t('language.popup.viewLogsPopup.update')+scope.row.updateNum+" "+$t('language.popup.viewLogsPopup.delete')+scope.row.deleteNum}}</div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('language.common.dataProcess')" min-width="175">
                                    <template slot-scope="scope">
                                        <div class="table-cell">{{scope.row.totalBytes|formatByte}} / {{scope.row.readedBytes|formatByte}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('language.popup.viewLogsPopup.tranTime')" min-width="155">
                                    <template slot-scope="scope">
                                        <div class="table-cell">{{scope.row.runningTime|conversionMilliseconds}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('language.popup.viewLogsPopup.executeResult')" min-width="175">
                                    <template slot-scope="scope">
                                        <div class="table-cell">
                                            <span v-if="scope.row.result==-1">{{$t('language.common.failure')}}</span>
                                            <span v-if="scope.row.result==0">{{$t('language.common.cancel')}}</span>
                                            <span v-if="scope.row.result==1">{{$t('language.common.success')}}</span>
                                            <span v-if="scope.row.result==2">{{$t('language.common.patial')}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import commonUtils from "@/js/workspace/common_util.js";
import taskListConvert from "@/js/workspace/task_list_convert.js";

export default {
    name: "viewLogs",
    // props: ["viewDetail"],
    components: {
    },
    data: function () {
        return {
            taskId: "",//当前页面任务id
            typeId: 100,//当前页面任务类型
            taskName: "",//当前页面任务名称
            viewLogsShow: false,
            loading: false,
            viewDetail: {},
            summary: {},//汇总信息
            singleSource: {},//来源信息
            multiSource: [],//目标信息
            syncSourceList: [],//同步多目标列表
            // syncSourceIndex: 0,//同步多目标列表index,用于隐藏已选中
            result: null,//任务结果
            lang: commonUtils.getLocaleToIndex(localStorage.getItem("locale")),
        }
    },
    computed: {
        showFromOrToTableName() {
            var res = "";
            if(this.lang=='jp') {
                switch (this.typeId) {
                    case 102:
                        res += this.$t('language.popup.viewLogsPopup.sync');
                        break;
                    case 103:
                        res += this.$t('language.popup.viewLogsPopup.backup');
                        break;
                    default:
                        res += this.$t('language.popup.viewLogsPopup.tran');
                        break;
                }
                if(this.viewDetail.type == 1 || (this.viewDetail.type == 6 && this.summary.tranferWay != 'restore')) {
                    res += this.$t('language.popup.viewLogsPopup.from')
                }else {
                    res += this.$t('language.popup.viewLogsPopup.to')
                }
            }else {
                if(this.viewDetail.type == 1 || (this.viewDetail.type == 6 && this.summary.tranferWay != 'restore')) {
                    res += this.$t('language.common.from')
                }else {
                    res += this.$t('language.common.to')
                }
            }
            return res;
        }
    },
    watch: {
        viewDetail: {
            handler(newValue,oldVal) {
                if(newValue) {
                    this.initDate(newValue);
                }else {
                    this.summary = false;
                }
            },
        }
    },
    methods: {
        initDate(detail) {
            console.log(detail)
            this.summary = {};//汇总信息
            this.singleSource = {};//来源信息
            this.multiSource = [];//目标信息
            this.syncSourceList = [];//同步多目标列表
            this.loading = true;
            if(detail.tasks) {
                if(!detail.tasks[0].lastLog||detail.tasks.length<1) {
                    //如果任务没有执行过
                    this.loading = false;
                    this.summary = null;
                    if(!this.taskName) {
                        this.taskName = detail.tasks[0].name;
                    }
                    this.multiSource = [];
                    return;
                }
                if(!this.taskName) {
                    this.taskName = detail.tasks[0].name;
                }
                detail.tasks[0].type = detail.type;
                if(detail.type == 2) {
                    this.typeId = 102;
                    this.initDateSync(detail);
                }else if(detail.type == 6) {
                    this.typeId = 103;
                    this.initDateBackup(detail);
                }else {
                    this.initDateDefault(detail);
                }
                console.log(detail.type)
                if(detail.type == 1 || detail.type == 6) {
                    //传输或备份还原任务单目标
                    this.singleSource = detail.tasks[0].toItem;
                }else {
                    //单源
                    this.singleSource = detail.tasks[0].fromItem;
                }
                if(detail.type == 2) {
                    this.result = this.syncSourceList[0].result;
                }else {
                    this.result = taskListConvert.convertResultByTasks(detail.tasks);
                }
            }else {
                if(detail.type == 3 || detail.type == 5) {
                    //暂不使用
                    this.taskName = detail.name;
                    console.log(this.taskName)
                    this.typeId = 105;
                    this.initDateRemoteUpload(detail);
                }
            }
            this.loading = false;
        },
        //默认传输
        initDateDefault(detail) {
            var that = this;
            //汇总信息
            var summary = {
                errorNum: 0,totalNum: 0,totalBytes: 0,runningTime: 0,
                type: detail.type,errorList: [],startTime: null,endTime: null,
            };
            if(this.typeId == 104) {
                let fromItem = detail.tasks[0].fromItem;
                summary.fromItem = fromItem.nodes[fromItem.nodes.length-1];
                let toItem = detail.tasks[0].toItem;
                summary.toItem = toItem.nodes[toItem.nodes.length-1];
            }

            //信息源
            detail.tasks.forEach(task => {
                //汇总信息
                var subTask;
                if(task.lastLog) {
                    subTask = that.initSingelTaskLog(task,summary,task.lastLog,detail.type);
                }
                if(this.typeId == 104) {
                    //企业传输
                    subTask.fromEmail = task.fromItem.fromEmail;
                    subTask.toEmail = task.toItem.toEmail;
                }
                that.multiSource.push(subTask);
            });
            console.log(summary)
            this.summary = summary;
        },
        //初始化同步
        initDateSync(detail) {
            var that = this;
            if(!detail.tasks[0].lastLog) return;
            
            var maxIndex = detail.tasks[0].lastLog.newLog.length;
            //多次任务循环
            for (let index = 0; index < maxIndex; index++) {
                const newLog = detail.tasks[0].lastLog.newLog[index];
                //汇总信息
                var summary = {
                    errorNum: 0,addNum: 0,updateNum: 0,deleteNum: 0,totalBytes: 0,runningTime: 0,
                    errorList: [],startTime: null,endTime: null,
                };

                //信息源
                var multiSource = [];
                detail.tasks.forEach(task => {
                    //汇总信息
                    var subTask;
                    if(task.lastLog && task.lastLog.newLog[index]) {
                        subTask = that.initSingelSyncTaskLog(task,summary,task.lastLog.newLog[index])
                    }else {
                        subTask = {
                            runningTime: 0,
                            addNum: 0,
                            updateNum: 0,
                            deleteNum: 0,
                            source: task.toItem
                        }
                    }
                    multiSource.push(subTask);
                });
                console.log(detail.tasks)
                //同步次数信息源列表
                var syncSource = {
                    summary: summary,
                    multiSource: multiSource,
                    result: taskListConvert.convertResult(newLog)
                }
                console.log(syncSource)
                that.syncSourceList.unshift(syncSource);
            }
            this.summary = this.syncSourceList[0].summary;
            this.multiSource = this.syncSourceList[0].multiSource;
        },
        //初始化备份
        initDateBackup(detail) {
            var that = this;
            //汇总信息
            var summary = {
                errorNum: 0,totalNum: 0,totalBytes: 0,runningTime: 0,
                tranferWay: detail.tasks[0].tranferWay,
                errorList: [],startTime: null,endTime: null,
            };

            //信息源
            detail.tasks.forEach(task => {
                //汇总信息
                var subTask;
                if(task.lastLog) {
                    subTask = that.initSingelTaskLog(task,summary,task.lastLog,detail.type);
                }

                if(summary.isMultiTask) {
                    //如果是多源备份，需要处理多源
                    let source = task.fromItem.data;
                    if(source) {
                        source.forEach(item => {
                            let newSubTask = JSON.parse(JSON.stringify(subTask));
                            newSubTask.source = item;
                            newSubTask.source.name = item.filename;
                            that.multiSource.push(newSubTask);
                        });
                    }
                }else {
                    that.multiSource.push(subTask);
                }
            });

            this.summary = summary;
        },
        //初始化离线上传(暂不使用)
        initDateRemoteUpload(detail) {
            var that = this;
            //汇总信息
            var summary = {
                startTime: detail.createTime,
                type: detail.type,
            };
            console.log(summary)
            //信息源
            detail.fromItem.lists.forEach(task => {
                //汇总信息
                var subTask;
                that.multiSource.push(task);
            });
            this.summary = summary;
        },
        //初始化单任务信息源
        initSingelTaskLog(task,summary,lastLog,type) {
            summary.totalNum += lastLog.readyTranFileCount;
            summary.totalBytes += lastLog.fileTotalReadedBytes;
            summary.runningTime += lastLog.taskElaspedTimeLong;

            if(lastLog.errorList) {
                summary.errorNum += lastLog.errorList.length;
                //添加识别任务id
                lastLog.errorList.forEach(err => {
                    err.taskId = task.id;
                });
                summary.errorList = summary.errorList.concat(lastLog.errorList);
            }

            this.initSummaryStartAndEndTime(summary,lastLog);

            var subTask = {
                readedBytes: lastLog.totalBytes,
                totalBytes: lastLog.fileTotalReadedBytes,
                totalNum: lastLog.totalFileCount,
                readyNum: lastLog.readyTranFileCount,
                runningTime: lastLog.taskElaspedTimeLong,
                result: taskListConvert.convertResult(task)
            }

            if(type == 1) {
                //传输或备份
                subTask.source = task.fromItem;
            }else if(type == 6){
                //备份还原任务
                if(summary.tranferWay == 'restore' && lastLog.restoreInfo.restoreNew) {
                    subTask.source = lastLog.restoreInfo.toItems[0];
                }else {
                    if(task.fromItem.data) {
                        //标记多源
                        summary.isMultiTask = true;
                    }else {
                        subTask.source = task.fromItem;
                    }
                }
            }else {
                //多目标
                subTask.source = task.toItem;
            }
            console.log(subTask)
            return subTask;
        },
        //初始化同步单任务信息源
        initSingelSyncTaskLog(task,summary,lastLog) {
            summary.addNum += lastLog.addFile;
            summary.updateNum += lastLog.updateFile;
            summary.deleteNum += lastLog.deleteFile;
            summary.totalBytes += lastLog.fileTotalReadedBytes;
            summary.runningTime += lastLog.taskElaspedTimeLong;

            if(lastLog.errorList) {
                summary.errorNum += lastLog.errorList.length;
                //添加识别任务id
                lastLog.errorList.forEach(err => {
                    err.taskId = task.id;
                });
                summary.errorList = summary.errorList.concat(lastLog.errorList);
            }

            this.initSummaryStartAndEndTime(summary,lastLog);

            var subTask = {
                readedBytes: lastLog.totalBytes,
                totalBytes: lastLog.fileTotalReadedBytes,
                totalNum: lastLog.totalFileCount,
                readyNum: lastLog.readyTranFileCount,
                runningTime: lastLog.taskElaspedTimeLong,
                result: taskListConvert.convertResult(lastLog)
            }

            //同步任务
            subTask.addNum = lastLog.addFile;
            subTask.updateNum = lastLog.updateFile;
            subTask.deleteNum = lastLog.deleteFile;
            subTask.source = task.toItem;
            return subTask;
        },
        initSummaryStartAndEndTime(summary,lastLog) {
            //任务总体起止时间
            let tempStartTime;
            if(lastLog.taskStartTimeStr) {
                tempStartTime = new Date(lastLog.taskStartTimeStr).getTime();
            }else if(lastLog.taskStartTime){
                tempStartTime = lastLog.taskStartTime;
            }
            if(!(summary.startTime && summary.startTime < tempStartTime)) {
                //之前的时间更早则不变,否则更换时间
                summary.startTime = tempStartTime;
            }
            if(lastLog.taskElaspedTimeLong) {
                let tempEndTime = tempStartTime + lastLog.taskElaspedTimeLong;
                if(!(summary.endTime && summary.endTime > tempEndTime)) {
                    //之前的时间更晚则不变,否则更换时间
                    summary.endTime = tempEndTime;
                }
            }
        },
        //切换同步源
        handleSyncSource(command) {
            this.summary = this.syncSourceList[command].summary;
            this.multiSource = this.syncSourceList[command].multiSource;
            this.result = this.syncSourceList[command].result;
        },
        //打开失败文件列表弹窗
        openFailedFiles() {
            let that = this;
            let failedFilesDialog = this.$parent.$refs.failedFilesDialog;
            let task = that.viewDetail.tasks[0];
            failedFilesDialog.transferType = this.viewDetail.type;
            failedFilesDialog.selectedArr = [];
            failedFilesDialog.unfinishData = Object.assign([], this.summary.errorList);
            failedFilesDialog.taskName = this.taskName;
            $.each(failedFilesDialog.unfinishData, function (index, item) {
                item.fromItem = Object.assign([], task.fromItem);
                item.toItem = Object.assign([], task.toItem);
                item.options = task.options;
            });
            that.$forceUpdate();
            failedFilesDialog.viewFailedFilesShow = true;
        },
        closePage() {
            this.taskId = "";//任务id
            this.typeId = 100;//任务id
            this.taskName = "";
            this.loading = false;
            this.viewDetail = {};
            this.summary = {};//汇总信息
            this.singleSource = {};//来源信息
            this.multiSource = [];//目标信息
            this.status = "";//任务状态
            this.viewLogsShow = false;
        },
        matchfileType(fileName) {
            if(!fileName) return "";
            return commonUtils.matchfileTypes(fileName);
        },
        jumpToCloudMult(item) {
            if(this.summary.type == 1 || this.summary.type == 6){
                this.toSourceCatalog(item,this.typeId);
            }else {
                this.toAimCatalog(item,this.typeId);
            }
        },
        jumpToCloud(item) {
            if(this.summary.type == 1 || this.summary.type == 6){
                this.toAimCatalog(item,this.typeId);
            }else {
                this.toSourceCatalog(item,this.typeId);
            }
        },
        toSourceCatalog(item,type) {
            this.$parent.toSourceCatalog(item,type);
        },
        toAimCatalog(item,type) {
            this.$parent.toAimCatalog(item,type);
        },
    }
}
</script>

<style scoped>
#viewLogs {
    width: 1200px;
    /*no*/
    height: 700px;
    /*no*/
}

.view-logs-body {
    padding: 20px;
    /*no*/
    display: flex;
    flex-direction: column;
    height: calc(100% - 80px);
    /*no*/
}

.view-logs-summary {
    margin-bottom: 50px;
    /*no*/
}

.task-status-icon-big {
    width: 40px;
    /*no*/
    height: 40px;
    /*no*/
    margin-right: 10px;
    /*no*/
    background-repeat: no-repeat;
    background-size: 100%;
}

.view-logs-status-item {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    /*no*/
    margin: 30px auto;
    /*no*/
}

.view-logs-status-item:has(.task-success) {
    color: #30A734;
}

.view-logs-status-item:has(.task-patial) {
    color: #E09D00;
}

.view-logs-status-item:has(.task-failure) {
    color: #F54958;
}

.view-logs-census {
    display: flex;
    justify-content: center;
    align-items: center;
}

.view-logs-count {
    text-align: center;
    position: relative;
    min-width: 134px;
    /*no*/
    padding: 0 10px;
    /*no*/
    font-size: 14px;
    /*no*/
}

.view-logs-count:before {
    content: "";
    border-right: 1px solid #BDBDBD;
    /*no*/
    height: 20px;
    /*no*/
    position: absolute;
    top: calc(50% - 10px);
    /*no*/
    right: 0;
}

.view-logs-count:last-child:before {
    display: none;
}

.view-logs-count-num {
    font-size: 20px;
    /*no*/
    margin-bottom: 1px;
    /*no*/
    text-decoration: none !important;
}

.view-logs-source {
    border: 1px solid #C1CBE3;
    flex-grow: 1;
    font-size: 12px;
    /*no*/
}

.view-logs-source-singel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding: 7px 20px 7px 34px;
    /*no*/
    background: #D3DCF0;
    box-sizing: border-box;
    border-width: 0px 0px 1px 0px;
    /*no*/
    border-style: solid;
    border-color: #D3DCF0;
}

.view-logs-source-singel .source-name {
    font-size: 14px;
    /*no*/
    font-weight: bold;
    display: flex;
    justify-content: left;
    align-items: center;
}

.view-logs-source-singel .source-name .path-name-txt {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 500px;
    /*no*/
}

.view-logs-source-singel .source-name .source-email-name {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 300px;
    /*no*/
    cursor: pointer;
}

.small-file {
    height: 20px;
    /*no*/
    width: 20px;
    /*no*/
    float: left;
    margin-right: 4px;
    /*no*/
}

.view-logs-source-table >>> .el-table__header {
    padding-left: 0;
}

.view-logs-source-table >>> .el-table__header .el-table__cell {
    height: 30px;
    /*no*/
    padding: 0;
    background: #F9FBFE;
}

.view-logs-source-table >>> .el-table__header .el-table__cell .cell {
    font-size: 14px;
    /*no*/
    color: #000000;
}

.view-logs-source-table >>> .el-table .el-table__cell .cell {
    padding-left: 15px;
    /*no*/
    font-weight: normal;
}

.view-logs-source-table.un-business-tran >>> .el-table__header .el-table__cell:first-child .cell{
    padding-left: 34px;
    /*no*/
}

.view-logs-source-table >>> .el-table__header .el-table__cell:before {
    content: "";
    border-left: 1px solid #D3DCF0;
    /*no*/
    height: 12px;
    /*no*/
    position: absolute;
    top: calc(50% - 6px);
    /*no*/
    left: 0;
}

.view-logs-source-table >>> .el-table__header .el-table__cell:first-child:before {
    display: none;
}

.view-logs-source-table >>> .el-table__header .el-table__cell:last-child:before {
    display: none;
}

.view-logs-source-table >>> .el-table td.el-table__cell {
    height: 60px;
    /*no*/
    padding: 0;
}

.view-logs-source-table >>> .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
    background: #F9FBFE;
}

.view-logs-source-table >>> .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background: #F2F7FE;
}

.view-logs-source-table >>>.el-table tbody td .table-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.have-click-text:hover div{
    text-decoration: underline;
    cursor: pointer;
}

.el-dropdown-link {
    cursor: pointer;
}

.clouds_logo {
    margin-right: 5px;
    /*no*/
}

.path-name-txt:hover {
    text-decoration: underline;
    cursor: pointer;
}

.view-logs-source-table >>>.el-table__body-wrapper {
    height: auto;
    overflow-y: auto;
    overflow-x: hidden;
}

.view-logs-source-table >>>.el-table__body-wrapper::-webkit-scrollbar,
.el-dropdown-menu::-webkit-scrollbar {
    width: 8Px;
    /*no*/
    height: 8Px;
    /*no*/
    background-color: transparent;
}

.view-logs-source-table >>>.el-table__body-wrapper::-webkit-scrollbar-thumb,
.el-dropdown-menu::-webkit-scrollbar-thumb {
    height: 1Px;
    /*no*/
    border-radius: 5Px;
    /*no*/
    background-color: #becae4;
}

.view-logs-source-table >>>.el-table__body-wrapper::-webkit-scrollbar-track,
.el-dropdown-menu::-webkit-scrollbar-track {
    background-color: transparent;
}

.logs-popup-drop.el-dropdown-menu__item:not(.is-disabled):hover{
    background-color: #F2F7FE;color: #5562B4;
}

.el-dropdown-menu {
    max-height: 200px; /* 设置最大高度 */
    overflow-y: auto; /* 启用垂直滚动条 */
}
</style>



// WEBPACK FOOTER //
// src/components/popup/task_list_popups/view_logs_popup.vue